import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Ellipsis, FlagIcon, Heart } from "lucide-react";
import { useEffect, useState, type FC } from "react";
import Text from "@/components/Text";
import AddRestaurantToFavorite from "@/components/dialogs/AddRestaurantToFavorite";
import useDetectSizeDevice from "@/hooks/useDetectSizeDevice";
import DrawerAddRestaurantToFavorite from "@/components/drawers/DrawerAddRestaurantToFavorite";
import { useTranslation } from "react-i18next";
import {
  addUserRestaurants,
  resetUserRestaurantsState,
  userAddRestaurantsState,
} from "@/store/userAddRestaurantsState";
import { toast } from "sonner";

type Props = {
  restaurantsId: string[];
};

const PopoverMoreActions: FC<Props> = ({ restaurantsId }) => {
  const { sm } = useDetectSizeDevice();
  const { t } = useTranslation();
  const { data: addRestaurantsStatus, isLoading: isAddingRestaurants } =
    userAddRestaurantsState();

  const [addFavoriteThisReastaurantId, setAddFavoriteThisReastaurantId] =
    useState<string[] | null>(null);

  useEffect(() => {
    if (addRestaurantsStatus) {
      toast.success("Restaurant(s) Ajouté(s)", {
        duration: 2000,
      });
      resetUserRestaurantsState();
    }
  }, [addRestaurantsStatus]);

  return (
    <>
      {sm ? (
        <AddRestaurantToFavorite
          open={!!addFavoriteThisReastaurantId}
          onClose={() => setAddFavoriteThisReastaurantId(null)}
          restaurantsId={addFavoriteThisReastaurantId ?? []}
        />
      ) : (
        <DrawerAddRestaurantToFavorite
          open={!!addFavoriteThisReastaurantId}
          onClose={() => setAddFavoriteThisReastaurantId(null)}
          restaurantsId={addFavoriteThisReastaurantId ?? []}
        />
      )}

      <Popover>
        <PopoverTrigger asChild>
          <Button variant="secondaryOutlined">
            <Ellipsis />
            Actions
          </Button>
        </PopoverTrigger>
        <PopoverContent>
          <Button
            className="w-[100%] justify-start"
            variant="secondaryOutlined"
            onClick={() => {
              setAddFavoriteThisReastaurantId(restaurantsId);
            }}
          >
            <Heart height={16} width={16} color="#44546F" />
            <Text fontSize={14} fontWeight={600}>
              {t("add_to_favorites_count", { count: restaurantsId.length })}
            </Text>
          </Button>

          <Button
            className="w-[100%] justify-start"
            variant="secondaryOutlined"
            onClick={() => {
              addUserRestaurants(restaurantsId);
            }}
            disabled={isAddingRestaurants}
          >
            <FlagIcon width={16} height={16} color="#44546F" />
            <Text fontSize={14} fontWeight={600}>
              {`${t("add_my_stores")} (${restaurantsId.length})`}
            </Text>
          </Button>
        </PopoverContent>
      </Popover>
    </>
  );
};

export default PopoverMoreActions;
